import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  Root,
  VideoContainer,
  Container,
  Title,
  Desc,
  Info,
} from './LessonVideoCard.style';

export const LessonVideoCard = ({
  title,
  desc,
  info,
  vimeoId,
  download,
  thumbnail,
}) => {
  return (
    <Root>
      {vimeoId ? (
        <VideoContainer>
          <iframe
            title={`${title}: ${desc}`}
            src={`https://player.vimeo.com/video/${vimeoId}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`}
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>

          {/* <script src="https://player.vimeo.com/api/player.js"></script> */}
        </VideoContainer>
      ) : (
        <div
          style={{
            position: 'relative',
            width: '100%',
          }}
        >
          <img src={thumbnail} alt={`${title} thumbnail`} />
        </div>
      )}
      <Container>
        <Title
          href={vimeoId && `https://vimeo.com/${vimeoId}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {title}
        </Title>
        {download == null ? (
          <Desc>{desc}</Desc>
        ) : (
          <Desc
            as="a"
            style={{ color: '#E1000F', textDecoration: 'underline' }}
            href={download}
            download
          >
            <FormattedMessage defaultMessage="Download" />
          </Desc>
        )}
      </Container>
    </Root>
  );
};

LessonVideoCard.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  info: PropTypes.string.isRequired,
  vimeoId: PropTypes.string,
  download: PropTypes.string,
};
